<template>
    <button :disabled="loading" v-html="btnLabel" class="btn btn-danger btn-xs" @click="confirmDeleteCarrierTax">
    </button>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "CarrierTaxDeleteButton",
    components: {},
    props: {
        carrierTax: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        confirmDeleteCarrierTax() {
            Swal.fire({
                title: this.$t("CarrierTaxDeleteButton.youSureToDelete"),
                text: this.$t("CarrierTaxDeleteButton.youCantUndo"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: this.$t("CarrierTaxDeleteButton.delete"),
                cancelButtonText: this.$t("CarrierTaxDeleteButton.cancel"),
            }).then(result => {
                if (result.value) {
                    this.deleteCarrierTax();
                }
            });
        },
        async deleteCarrierTax() {
            try {
                this.loading = true;
                await this.$diceAPI.deleteCarrierTax(this.carrierTax);
                this.$emit("deleteCarrierTax", this.carrierTax);
                this.$toasted.success(this.$t("CarrierTaxDeleteButton.carrierTaxDeleted"), { icon: "check" });
            } catch (e) {
                this.$displayError(e);
            } finally {
                this.loading = false;
            }
        },
    },
    computed: {
        btnLabel() {
            return this.loading ? "<i class='fa fa-spin fa-spinner'></i>" : "<i class='fa fa-times'></i>";
        },
    },
};
</script>

<style scoped>

</style>